<template>
  <div class="BoxContent" @touchmove.prevent>
    <div class="boxOne">
      <svg-btn class="icon" icon-class="icon-short-no"></svg-btn>
      <span class="font1"
        >该短链已被系统审核过滤或被分享者删除，无法访问</span
      >
      <!-- <div class="bottomBox">
        <div class="left">
          <span class="font2">参考资料：</span>
          <span class="font3" @click="goHelp(98)"
            >《Feemoo内容审核机制公示》</span
          >
        </div>
        <div class="right">
          <span class="font2">如有疑问可访问：</span>
          <span class="font3" @click="goHelp(0)">《Feemoo帮助中心》</span>
        </div>
      </div> -->
    </div>
    <!-- <div class="boxTwo">
      <el-carousel
        :interval="3000"
        trigger="click"
        ref="slideCarousel"
        arrow="never"
      >
        <el-carousel-item
          v-for="(item, index) in $store.state.banner"
          :key="index"
        >
          <img :src="item.img" class="img" @click="open(item.url)" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    //调用方法
    // this.slideBanner()
  },
  methods: {
    open(url) {
      window.open(url, '_href')
    },
    goHelp(type) {
      let url
      if (type == 0) {
        url = this.$glb.feemooUrl + '/help'
      } else {
        url = this.$glb.feemooUrl + '/askdetail/98'
      }
      window.location.href = url
    },
    // 滑动切换
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container')
      var startPoint = 0
      var stopPoint = 0
      //重置坐标
      var resetPoint = function () {
        startPoint = 0
        stopPoint = 0
      }
      //手指按下
      box.addEventListener('touchstart', function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX
      })
      //手指滑动
      box.addEventListener('touchmove', function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX
      })
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener('touchend', function (e) {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint()
          return
        }
        if (startPoint - stopPoint > 0) {
          resetPoint()
          that.$refs.slideCarousel.next()
          return
        }
        if (startPoint - stopPoint < 0) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          return
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.BoxContent {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  height: 100%;
  .boxOne {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #ffffff;
    border-radius: 32px;
    width: 100%;
    padding: 20px 32px 20px 32px;
    min-height: 166px;
    margin-bottom: 16px;
    .icon {
      width: 28px;
      height: 28px;
    }
    .font1 {
      font-weight: 500;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 20px;
      margin-top: 14px;
      text-align: center;
      word-break: break-all;
    }
    .bottomBox {
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      .font2 {
        font-weight: 400;
        font-size: 11px;
        color: #8a8b92;
        line-height: 16px;
      }
      .font3 {
        cursor: pointer;
        font-weight: 400;
        font-size: 11px;
        line-height: 16px;
        color: #f67942 !important;
      }
    }
  }
  .boxTwo {
    width: 100%;
    height: 188px;
    background: #ffffff;
    border-radius: 32px;
    ::v-deep .el-carousel {
      height: 100%;
      border-radius: 32px;
      .el-carousel__container {
        height: 100% !important;
      }
      .el-carousel__indicator {
        padding: 0;
        margin-right: 4px;
        margin-bottom: 10px;
      }
      .is-active {
        .el-carousel__button {
          opacity: 1 !important;
          width: 8px !important;
        }
      }
      .el-carousel__button {
        width: 3px;
        height: 3px;
        background: #ffffff;
        border-radius: 1.5px;
        opacity: 0.4;
      }
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 32px;
    }
  }
}
</style>
